import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgProgress } from '@ngx-progressbar/core';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import {
  DataBindingDirective,
  SelectableSettings
} from '@progress/kendo-angular-grid';
import { CheckableSettings } from '@progress/kendo-angular-treeview';
import { process } from '@progress/kendo-data-query';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Observable, of } from 'rxjs';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { ConfirmationComponent } from '../../../../shared/components/confirmation/confirmation.component';
import { matchExternalSSO } from '../../../../shared/constants/external-sso.constants';
import { ConfirmationModel } from '../../../../shared/model/confirmation.model';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { SEARCH_QUITE_PERIOD } from '../../../../shared/utils/miscellaneous.utils';
import { SortUtils } from '../../../../shared/utils/sort.utils';
import { AuthService } from '../../../security/service/auth.service';
import {
  CustomerModel,
  GroupModel,
  PersonaModel,
  SearchSiteTier,
  ServiceProviderModel,
  Sites,
  SiteTierArray
} from '../../../user/model/user.model';
import { UsersService } from '../../../user/service/users.service';
import { CustomerGroupModel } from '../../model/customer-group.model';
import { CustomerMapModel } from '../../model/customer-map.model';

@Component({
  selector: 'customer-new-user',
  templateUrl:
    './console/app-js/modules/customerUser/components/customer-new-user/customer-new-user.component.html'
})
export class CustomerNewUserComponent extends APIOperableComponent
  implements OnInit {
  public static CUSTOMERGROUP: string = 'Customer';
  public static CUSTOMERQUOTEVIEWERGROUP: string = 'Customer Quote Viewer';
  public static CUSTOMERQUOTEAPPROVERGROUP: string = 'Customer Quote Approver';
  public static CUSTOMERINVOICEVIEWERGROUP: string = 'Customer Invoice Viewer';
  public static REPORTVIEWERGROUP: string = 'Report Viewer';
  public static CUSTOMERRUNREPORTVIEWERGROUP: string =
    'Customer Run Report Viewer';
  public static CUSTOMERPRIORITYEDITORGROUP: string =
    'Customer Priority Editor';

  public groupsToFind = [
    CustomerNewUserComponent.CUSTOMERGROUP,
    CustomerNewUserComponent.CUSTOMERQUOTEVIEWERGROUP,
    CustomerNewUserComponent.CUSTOMERQUOTEAPPROVERGROUP,
    CustomerNewUserComponent.CUSTOMERINVOICEVIEWERGROUP,
    CustomerNewUserComponent.REPORTVIEWERGROUP,
    CustomerNewUserComponent.CUSTOMERRUNREPORTVIEWERGROUP,
    CustomerNewUserComponent.CUSTOMERPRIORITYEDITORGROUP
  ];

  public static CUSTOMERADD = 'Add User';
  public static CUSTOMEREDIT = 'Edit User';

  public groupLookup: Map<string, any> = new Map<string, any>();
  isCorporateUser: boolean = false;
  public isSiteSearched: boolean = false;
  isCustomerQuoteViewer: boolean = false;
  isCustomerInvoiceViewer: boolean = false;
  isCustomerQuoteApprover: boolean = false;
  isReportViewer: boolean = false;
  isCustomerRunReportViewer: boolean = false;
  isCustomerPriorityEditor: boolean = false;
  isCustomerQuoteViewerAdded: boolean = false;
  isCustomerInvoiceViewerAdded: boolean = false;
  isCustomerQuoteApproverAdded: boolean = false;
  isReportViewerAdded: boolean = false;
  isCustomerRunReportViewerAdded: boolean = false;
  isCustomerPriorityEditorAdded: boolean = false;
  public siteAccessData: any[] = [];
  protected loading = false;

  @Input() customerNumber: any;
  @Input('opened') opened = false;
  @Input('title') title = CustomerNewUserComponent.CUSTOMEREDIT;
  @Input('user') customerUser: any;
  @Output() closed = new EventEmitter<any>();
  @ViewChild('templateForm', { static: true }) templateForm: NgForm;
  @ViewChild(DataBindingDirective, { static: false })
  dataBinding: DataBindingDirective;
  @ViewChildren('kendoMultiSelectInstance')
  protected kendoMultiSelectInstances: Array<MultiSelectComponent>;
  @ViewChild('kendoMultiSelectInstance', { static: true })
  protected kendoMultiSelectInstance: MultiSelectComponent;
  protected originalData: Array<any> = [];
  protected temporaryData: Array<any> = [];
  protected groupList: Array<any> = [];
  public siteTierMap: SiteTierArray;
  public siteTierArray: SiteTierArray[] = [];
  protected groupsSelected: Array<any> = [];
  protected tempGroupsSelected: Array<any> = [];
  protected personaSelected: any;
  public isValidEmail = true;
  public emailTooLong = false;
  protected selectedSites: any;
  protected sitesList: Array<any> = [];
  protected originalSitesData: Array<any> = [];
  protected sitesLoadingIndicator: boolean;
  protected selectedCustomers: any;
  protected customersList: Array<any> = [];
  protected originalCustomersData: Array<any> = [];
  protected customersLoadingIndicator: boolean;
  protected personasList: Array<PersonaModel>;
  protected groupsOnly: Array<GroupModel>;
  protected selectedProviders: any;
  protected initialGroup: any;
  protected personaName: string;
  protected firstNameDisabled: boolean;
  protected lastNameDisabled: boolean;
  protected emailDisabled: boolean = false;
  protected roleDisabled: boolean;
  protected providerAccessDisabled: boolean;
  public isVixxoEmail: boolean;
  public isEnterpriseSP: boolean;
  private hasChanges: boolean;
  public data: any;
  public isMultipleServiceProviderAccess: boolean;
  public filterGridData: any;
  public selectableSettings: SelectableSettings = {
    enabled: true,
    mode: 'multiple',
    checkboxOnly: true
  };
  public selectedAccessProviderNumber: any[] = [];
  public spAccessNumber: any;
  public isFormValid: Boolean = false;
  public dataSP = [];
  public spDataLoadLength = 100;
  public countSP = 0;
  public searchData: string;
  public allGroupsList: any = [];
  public user: any;
  public sortedSPList: any;
  public isSPGridLoading: Boolean = true;
  public statusSwitch: boolean = true;
  public statusDeactivated: boolean;
  public statusActive: string;
  public isAuth0EmailExists = false;
  public federatedSSOMatch: boolean = false;
  private pendingDuplicateRolesSnapshot: {
    isCustomerQuoteViewer: boolean;
    isCustomerQuoteApprover: boolean;
    isCustomerInvoiceViewer: boolean;
    isReportViewer: boolean;
    isCustomerRunReportViewer: boolean;
    isCustomerPriorityEditor: boolean;
  } | null = null;
  public sortedSPListAll: any;
  public quoteLimitNumberEntry: any;
  public isQuoteLimitViewer: boolean = false;
  public showQuoteLimitError: boolean = false;
  public showNoQuoteLimitInputError: boolean = false;
  public enableCheck = true;
  public checkChildren = true;
  public checkParents = true;
  public checkOnClick = false;
  public checkMode: any = 'multiple';
  public typingTimeout: any;
  public checkedSiteKey: any;
  public siteTierData: any[] = [];
  public expandedTier: any;
  public checkedKeys: any[] = [];
  public checkedSiteKeys: any[] = [];
  public selectedKeys: any[] = [];
  public expandedKeys: any[] = [];
  public searchQuery: string = '';
  public siteData: any;
  public siteIds: any = [];
  public siteTiers: any = [];
  public editSiteTiers: any = [];
  public editSiteIds: any = [];
  public pageSize: number = 10;
  public displaySiteTierValidation: boolean = false;
  public customerSubmit: boolean = false;
  public showSiteAccessTab: boolean = true;
  public siteTierResponse: any;
  public loadedSiebelSiteIds: any[] = [];
  public loadedTierIds: any[] = [];
  private claimQuoteApproverLimit: any = 'QuoteApprovalLimit';
  private claimCorporateAccess: any = 'CorporateAccess';
  public expandedKeysForSiteSearch: any[] = [
    '0',
    '0_0',
    '0_0_0',
    '0_0_0_0',
    '0_0_0_0_0'
  ];
  protected allCustomers: Array<CustomerMapModel> = [];
  protected selectedCustomer: Array<CustomerMapModel> = [];
  protected originalAllCustomers: Array<CustomerMapModel> = [];
  public isTierDataAvailable: boolean = true;
  public sitesData: Sites[];
  public selectedSiteNumbers: number[] = [];
  public filterSiteGridData: Sites[];
  public siteGridSearchControl: string;
  private initialUserStatus: string;

  constructor(
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private usersService: UsersService,
    private dialogService: UIDialogService
  ) {
    super(progressService, toastr, authService);
  }

  public get checkableSettings(): CheckableSettings {
    return {
      checkChildren: this.checkChildren,
      checkParents: this.checkParents,
      enabled: this.enableCheck,
      mode: this.checkMode,
      checkOnClick: this.checkOnClick
    };
  }

  public children = (dataItem: any): Observable<any[]> => of(dataItem.child);

  public hasChildren = (dataItem: any) =>
    dataItem && (!(dataItem.level == 0) || !!dataItem.child);

  ngOnInit() {
    this.loading = true;
    this.user = { ...this.customerUser };

    if (!this.customerNumber && this.user.customerNumbers) {
      this.customerNumber = this.user.customerNumbers[0];
    }

    this.setTierData();
    this.personaSelected = {};
    if (this.authService.isEnterpriseSPUserManager()) {
      this.isEnterpriseSP = true;
      this.personaSelected.persona = 'Service Provider';
    } else {
      this.isEnterpriseSP = false;
    }

    this.usersService.getGroups().subscribe((results: any) => {
      results.groups.forEach((group: any) => {
        this.allGroupsList.push(group);
      });

      this.allGroupsList.forEach((group: any) => {
        if (this.groupsToFind.indexOf(group.name) > -1) {
          this.groupLookup.set(group.name, group);
        }
      });
    });

    this.getCustomerGroupCustomers();

    if (this.user.isEdit) {
      this.emailDisabled = true;
      this.loadingIndicator = true;
      this.selectedAccessProviderNumber = this.user.serviceProviderNumbers;

      if (this.user.status && this.user.status === 'Active') {
        this.statusSwitch = true;
        this.statusActive = this.user.status;
        this.enableEditFields();
      } else {
        this.statusSwitch = false;
        this.statusActive = this.user.status;
        this.disableEditFields();
      }

      this.initialUserStatus = this.user.status;

      this.usersService.getUserInfo(this.user).subscribe((res: any) => {
        if (res.siteTiers) {
          this.checkedKeys = res.siteTiers;
        }

        if (res.siteIds) {
          this.editSiteIds = res.siteIds;
          this.selectedSiteNumbers = res.siteIds;
          if (this.checkedKeys.length) {
            this.checkedKeys.push(res.siteIds);
          } else {
            this.checkedKeys = res.siteIds;
          }
        }

        this.checkedKeys = this.flattenArray(this.checkedKeys);
        this.editSiteTiers = this.checkedKeys.filter(
          item => !this.editSiteIds.includes(item)
        );

        this.setGroupsAndQuoteLimit(res);

        if (
          this.user.QuoteApprovalLimit == undefined ||
          (!this.isCustomerQuoteApprover &&
            this.user.QuoteApprovalLimit != undefined)
        ) {
          this.loadingIndicator = true;
          this.loading = true;
          this.usersService
            .getUserInfo(this.user)
            .subscribe((retryResult: any) => {
              this.setGroupsAndQuoteLimit(retryResult);

              if (
                this.user.QuoteApprovalLimit == undefined ||
                (!this.isCustomerQuoteApprover &&
                  this.user.QuoteApprovalLimit != undefined)
              ) {
                this.usersService
                  .getUserInfo(this.user)
                  .subscribe((retryResult: any) => {
                    this.setGroupsAndQuoteLimit(retryResult);
                  });
              }
              this.loadingIndicator = false;
              this.loading = false;
            });
        } else {
          this.loadingIndicator = false;
          this.loading = false;
        }
      });
      this.checkVixxoEmail(this.user.email);
      this.updateChanges();
    }
  }

  showSiteTab(value: boolean): void {
    this.showSiteAccessTab = value;
  }

  searchSP(searchInput: string) {
    this.searchQuery = searchInput ? searchInput : '';
    if (this.searchQuery && this.searchQuery.trim().length > 2) {
      this.isSiteSearched = true;
      clearTimeout(this.typingTimeout);
      this.typingTimeout = setTimeout(
        () => this.getSiteSearch(this.searchQuery.trim()),
        SEARCH_QUITE_PERIOD
      );
    } else {
      this.isSiteSearched = false;
    }
  }

  setGroupsAndQuoteLimit(res: any) {
    let quoteApprover = false;
    if (res && res.groups && res.groups.length > 0) {
      res.groups.forEach((group: any) => {
        if (
          group.name.toLowerCase() ===
          CustomerNewUserComponent.CUSTOMERQUOTEVIEWERGROUP.toLowerCase()
        ) {
          this.isCustomerQuoteViewer = this.isCustomerQuoteViewerAdded = true;
        }
        if (
          group.name.toLowerCase() ===
          CustomerNewUserComponent.CUSTOMERQUOTEAPPROVERGROUP.toLowerCase()
        ) {
          quoteApprover = true;
          this.isCustomerQuoteApprover = this.isCustomerQuoteApproverAdded = true;
        }

        if (
          group.name.toLowerCase() ===
          CustomerNewUserComponent.CUSTOMERINVOICEVIEWERGROUP.toLowerCase()
        ) {
          this.isCustomerInvoiceViewer = this.isCustomerInvoiceViewerAdded = true;
        }

        if (
          group.name.toLowerCase() ===
          CustomerNewUserComponent.REPORTVIEWERGROUP.toLowerCase()
        ) {
          this.isReportViewer = this.isReportViewerAdded = true;
        }
        if (
          group.name.toLowerCase() ===
          CustomerNewUserComponent.CUSTOMERRUNREPORTVIEWERGROUP.toLowerCase()
        ) {
          this.isCustomerRunReportViewer = this.isCustomerRunReportViewerAdded = true;
        }
        if (
          group.name.toLowerCase() ===
          CustomerNewUserComponent.CUSTOMERPRIORITYEDITORGROUP.toLowerCase()
        ) {
          this.isCustomerPriorityEditor = this.isCustomerPriorityEditorAdded = true;
        }
      });

      let claims = res.claims;
      if (claims && claims.length >= 1) {
        if (quoteApprover) {
          this.isQuoteLimitViewer = true;
          let quoteLimit = claims.find(
            (claim: any) => claim.claimType === this.claimQuoteApproverLimit
          );
          if (quoteLimit) {
            this.user.QuoteApprovalLimit = parseInt(quoteLimit.claimValue);
            this.validateQuoteLimit();
          }
        }

        let corporateAccess = claims.find(
          (claim: any) => claim.claimType === this.claimCorporateAccess
        );
        if (
          corporateAccess &&
          corporateAccess.claimValue &&
          corporateAccess.claimValue != ''
        ) {
          this.isCorporateUser = true;
        }
      }
    }
  }

  getCustomerGroupCustomers(): void {
    this.loadingIndicator = true;
    this.usersService.getCustomerGroupCustomers(this.customerNumber).subscribe(
      (res: Array<CustomerGroupModel>) => {
        if (res && res.length > 0) {
          let results: Array<CustomerMapModel> = res.map((cust, index) => {
            return {
              id: index,
              number: cust.customerNumber,
              name: cust.customerNumber
            };
          });

          this.originalAllCustomers = results;
          this.selectedCustomer = results.filter(
            (customers: any) => customers.number === this.customerNumber
          );
          const userInfoClaimValue = this.user.customerNumbers
            ? this.user.customerNumbers
            : [];

          if (userInfoClaimValue) {
            const filterCustomer = this.selectedCustomer.map(
              item => item.number
            );

            let missingCustomer = userInfoClaimValue.filter(
              item => filterCustomer.indexOf(item) < 0
            );
            missingCustomer.forEach(selectedCust => {
              let obj: CustomerMapModel = {
                id: null,
                number: selectedCust,
                name: selectedCust
              };
              this.selectedCustomer.push(obj);
            });
          }

          // Map selected customers to allcustomers to update ID
          this.selectedCustomer.forEach(selectedCust => {
            results.forEach(cust => {
              if (selectedCust.number === cust.number) {
                selectedCust.id = cust.id;
              }
            });
          });
          this.loadingIndicator = false;
          this.allCustomers = results.sort((a, b) =>
            SortUtils.compareByProperty(a, b, 'number')
          );
        } else {
          this.loadingIndicator = false;
          let obj: CustomerMapModel = {
            id: 1,
            number: this.customerNumber,
            name: this.customerNumber
          };
          this.selectedCustomer.push(obj);
          this.allCustomers = this.selectedCustomer;
        }
      },
      () =>
        this.onAPIError('An error occurred while loading the list of Customer.')
    );
  }

  setTierData() {
    this.usersService.getTiers(this.customerNumber).subscribe((tiers: any) => {
      if (tiers && tiers.length > 0) {
        tiers.forEach(tier => {
          if (tier.tierId) {
            this.loadedTierIds.push(tier.tierId);
            this.siteTierData.push(tier);
          }
        });
        this.pageSize = this.siteTierData.length;
        if (!this.user.isEdit) {
          this.loading = false;
        }
      } else {
        this.isTierDataAvailable = false;
        this.checkedKeys = [];
        this.getSite();
      }
    });
  }

  getSite(): void {
    this.loading = true;
    this.usersService
      .getSitesByCustomerId(this.customerNumber)
      .subscribe((sites: Sites[]) => {
        this.sitesData = sites;
        this.sitesData.forEach(site => {
          site.siteName = site.name + ' - ' + site.number;
        });
        this.filterSiteGridData = this.sitesData;
        this.loading = false;
      });
  }

  onSelectedSiteNumberChange(): void {
    if (this.isCorporateUser) {
      this.displaySiteTierValidation = false;
    } else if (this.selectedSiteNumbers.length) {
      this.displaySiteTierValidation = !this.selectedSiteNumbers.length;
    } else {
      this.displaySiteTierValidation = true;
    }
  }

  public onFilter(inputValue: string): void {
    this.siteGridSearchControl = inputValue;
    this.sitesData = process(this.filterSiteGridData, {
      filter: {
        logic: 'or',
        filters: [
          {
            field: 'siteName',
            operator: 'contains',
            value: inputValue
          }
        ]
      }
    }).data;

    this.dataBinding.skip = 0;
  }

  getSiteSearch(siteId: string) {
    this.loading = true;
    this.siteTierArray = [];
    this.siteTierMap = { items: [], text: '' };
    this.usersService
      .getSearchSites(this.customerNumber, siteId)
      .subscribe((sites: SearchSiteTier[]) => {
        if (sites && sites.length > 0) {
          if (this.checkedKeys && this.checkedKeys.length > 0) {
            const index: number = this.checkedKeys.indexOf(
              sites[0].siebelSiteId
            );
            if (index !== -1) {
              this.checkedSiteKeys.push(sites[0].siebelSiteId);
            } else {
              this.checkedSiteKeys = [];
            }
          } else {
            this.checkedSiteKeys = [];
          }
          this.loadSitesTreeView(sites);
        }
        this.loading = false;
      });
  }

  updateCheckedSiteKey() {
    if (this.checkedSiteKey && this.checkedSiteKey.siteId) {
      if (this.checkedKeys && this.checkedKeys.length > 0) {
        const index: number = this.checkedKeys.indexOf(
          this.checkedSiteKey.siteId
        );
        if (index !== -1) {
          this.checkedKeys.splice(index, 1);
        } else {
          this.checkedKeys.push(this.checkedSiteKey.siteId);
        }
      } else {
        this.checkedKeys.push(this.checkedSiteKey.siteId);
      }
    }
    this.checkedSiteKey = {};
  }

  public appendChildProperty(object, responseToAppend) {
    return Object.assign(object, { child: responseToAppend });
  }

  checkForTierIdAndLevel(tierId, level) {
    return (
      tierId === this.expandedTier.tierId && level === this.expandedTier.level
    );
  }

  public handleExpand(event) {
    this.expandedTier = event;
    if (
      this.expandedTier != undefined &&
      this.expandedTier.child == undefined
    ) {
      //condition to prevent api calling
      this.loading = true;
      const params = {
        parentLevel: this.expandedTier.level,
        parentTierId: this.expandedTier.tierId
      };

      this.usersService
        .getTiers(this.customerNumber, params)
        .subscribe((tierResponse: any) => {
          if (tierResponse && tierResponse.length) {
            tierResponse.forEach(element => {
              this.loadedTierIds.push(element.tierId);
              Object.assign(element, {
                parentTierId: this.expandedTier
                  ? this.expandedTier.tierId
                  : null
              });
            });
            this.siteData = [];
            this.pageSize = tierResponse.length;
            this.siteTierResponse = tierResponse;

            this.checkForLevelToAppendData(this.siteTierData);
            if (this.user.isEdit) {
              this.removeItemsFromCheckedKeys(
                this.expandedTier.tierId,
                this.siteTierResponse
              );
            }
            this.loading = false;
          }
          if (tierResponse.length == 0) {
            Object.assign(params, { pageSize: 50 });
            this.getSites(params);
          }
          this.expandedKeys.push(event.tierId);
        });
    } else if (this.expandedTier.child) {
      const parentTierId = this.expandedTier.parentTierId;
      if (
        !this.checkIdExist(parentTierId) &&
        this.checkAllElementsSelected(this.expandedTier.child)
      ) {
        this.expandedTier.child.forEach(element => {
          const index = this.checkedKeys.indexOf(element.tierId);
          if (index > -1) {
            this.checkedKeys.splice(index, 1);
          }
        });
      }
    }
  }

  RemoveDeselectKey() {
    if (!this.user.isEdit) {
      this.selectedKeys.forEach((element, index) => {
        const checkedKeyIndex: number = this.checkedKeys.indexOf(element);
        if (checkedKeyIndex == -1) {
          this.selectedKeys.splice(index, 1);
        }
      });
    } else {
      this.editSiteIds.forEach((element, index) => {
        const checkedKeyIndex: number = this.checkedKeys.indexOf(element);
        if (checkedKeyIndex == -1) {
          this.editSiteIds.splice(index, 1);
        }
      });
    }
  }

  checkAllElementsSelected(elements: []) {
    let isAllChildSelected = true;
    elements.forEach((child: any) => {
      if (!this.checkIdExist(child.tierId)) {
        isAllChildSelected = false;
      }
    });
    return isAllChildSelected;
  }

  checkIdExist(id) {
    let found = false;
    this.checkedKeys.forEach(tierId => {
      if (tierId == id) {
        found = true;
      }
    });
    return found;
  }

  removeItemsFromCheckedKeys(parentTierId: any, childData: any[]) {
    let absentCount = 0;
    if (!this.checkedKeys.find(x => x == parentTierId)) {
      childData.forEach(element => {
        if (!this.checkedKeys.find(x => x == element.tierId)) {
          absentCount++;
        }
      });
      if (absentCount == 0) {
        childData.forEach(elementToBeRemoved => {
          const index = this.checkedKeys.indexOf(elementToBeRemoved.tierId);
          if (index > -1) {
            this.checkedKeys.splice(index, 1);
          }
        });
      }
      //check if all the tierIds are present inside checkedKeys, then remove else keep it as it is
    }
  }

  handleCollapse(event) {
    const index = this.expandedKeys.indexOf(event.tierId);
    if (index > -1) {
      this.expandedKeys.splice(index, 1);
    }
  }

  getSites(params: any) {
    this.usersService
      .getSites(this.customerNumber, params)
      .subscribe((siteResponse: any) => {
        if (siteResponse && siteResponse.paging.pageNumber > 1) {
          params.pageSize = siteResponse.paging.resultTotal;
          this.getSites(params);
        } else {
          this.getAllSites(siteResponse);
        }
        this.loading = false;
      });
  }

  getSelectedIds = (nestedObjects: any) => {
    return nestedObjects.reduce((totalValue, nestedObject: any): any => {
      if (
        nestedObject.isSelected &&
        nestedObject.isParentTierIdSelected == undefined &&
        nestedObject.level == 1
      ) {
        this.selectedKeys.push(nestedObject.tierId);
      } else if (
        nestedObject.isSelected &&
        !nestedObject.isParentTierIdSelected
      ) {
        this.selectedKeys.push(nestedObject.tierId);
      } else if (nestedObject.child) {
        totalValue += this.getSelectedIds(nestedObject.child);
      }
      return totalValue;
    }, 0);
  };

  formDataWithSelectionInformation = (nestedObjects: any) => {
    return nestedObjects.reduce((totalValue, nestedObject: any): any => {
      if (this.checkedKeys.find(id => id == nestedObject.tierId)) {
        Object.assign(nestedObject, { isSelected: true });
      }
      if (
        this.checkedKeys.find(id => id == nestedObject.tierId) &&
        nestedObject.level == 1
      ) {
        Object.assign(nestedObject, { isSelected: true });
      }
      if (this.checkedKeys.find(id => id == nestedObject.parentTierId)) {
        Object.assign(nestedObject, { isParentTierIdSelected: true });
      } else {
        Object.assign(nestedObject, { isParentTierIdSelected: false });
      }
      if (nestedObject.child) {
        if (!nestedObject.isSelected) {
          Object.assign(nestedObject, { isSelected: false });
        }

        totalValue += this.formDataWithSelectionInformation(nestedObject.child);
      }
      return totalValue;
    }, 0);
  };

  getAllSites(siteResponse) {
    this.siteData = siteResponse; //data with pagination values
    const siteResult = this.modifySiteData(siteResponse.results);
    siteResult.forEach(element => {
      this.loadedSiebelSiteIds.push(element.tierId);
      Object.assign(element, {
        parentTierId: this.expandedTier ? this.expandedTier.tierId : null
      });
    });
    this.loadedSiebelSiteIds = this.flattenArray(this.loadedSiebelSiteIds);
    this.siteTierResponse = this.removeInvalidSites(siteResult);
    this.removeItemsFromCheckedKeys(
      this.expandedTier.tierId,
      this.siteTierResponse
    );
    this.checkForLevelToAppendData(this.siteTierData);
  }

  removeInvalidSites(sites) {
    let site = [];
    sites.forEach(element => {
      if (
        element.tierId !== 0 &&
        element.tierId != null &&
        element.tierId != undefined
      ) {
        site.push(element);
      }
    });
    return site;
  }

  checkedKeyValidation(event) {
    if (this.isCorporateUser) {
      this.displaySiteTierValidation = false;
    } else if (this.checkedKeys.length > 1) {
      this.displaySiteTierValidation = !this.checkedKeys.length;
    } else {
      this.displaySiteTierValidation = this.checkedKeys.find(
        x => x == event.item.dataItem.tierId
      );
    }
  }

  checkedKeySites(event: any) {
    if (this.checkedSiteKeys && this.checkedSiteKeys.length > 0) {
      const index: number = this.checkedSiteKeys.indexOf(
        event.item.dataItem.value
      );
      if (index !== -1) {
        this.checkedSiteKey = {
          siteId: event.item.dataItem.value,
          isChecked: false
        };
      } else {
        this.checkedSiteKey = {
          siteId: event.item.dataItem.value,
          isChecked: true
        };
      }
    } else {
      this.checkedSiteKey = {
        siteId: event.item.dataItem.value,
        isChecked: true
      };
    }
    if (this.user.isEdit) {
      this.EditCheckedSelectedSites(event.item.dataItem.value);
    } else {
      this.AddCheckedSelectedSites(event.item.dataItem.value);
    }
    this.updateCheckedSiteKey();
    this.checkedSiteSearchKeyValidation();
  }

  checkedSiteSearchKeyValidation() {
    if (this.isCorporateUser || this.checkedKeys.length > 0) {
      this.displaySiteTierValidation = false;
    } else {
      this.displaySiteTierValidation = true;
    }
  }

  EditCheckedSelectedSites(siteId: string) {
    if (this.editSiteIds && this.editSiteIds.length > 0) {
      const index: number = this.editSiteIds.indexOf(siteId);
      if (index !== -1) {
        this.editSiteIds.splice(index, 1);
      } else {
        this.editSiteIds.push(siteId);
      }
    } else {
      this.editSiteIds.push(siteId);
    }
  }

  AddCheckedSelectedSites(siteId: string) {
    if (this.selectedKeys && this.selectedKeys.length > 0) {
      const index: number = this.selectedKeys.indexOf(siteId);
      if (index !== -1) {
        this.selectedKeys.splice(index, 1);
      } else {
        this.selectedKeys.push(siteId);
      }
    } else {
      this.selectedKeys.push(siteId);
    }
  }

  //modifying site data to match the stricture of tier to display on kendo tree view
  modifySiteData(site: any) {
    return site.map(({ siteName: tierName, siebelSiteId: tierId, level }) => ({
      tierName,
      tierId,
      level
    }));
  }

  //Method to form tree view structure
  checkForLevelToAppendData = (nestedObjects: any) => {
    return nestedObjects.reduce((totalValue, nestedObject: any): any => {
      if (
        this.checkForTierIdAndLevel(nestedObject.tierId, nestedObject.level)
      ) {
        totalValue = this.appendChildProperty(
          nestedObject,
          this.siteTierResponse
        );
      } else if (nestedObject.child) {
        totalValue += this.checkForLevelToAppendData(nestedObject.child);
      }
      return totalValue;
    }, 0);
  };

  public saveCheckedData(event: any) {
    const index = this.siteAccessData
      ? this.siteAccessData.findIndex(event.item.tierId)
      : -1;
    if (index > -1) {
      this.siteAccessData.splice(index, 1);
    } else {
      this.siteAccessData.push(event.item.tierId);
    }
  }

  private enableEditFields() {
    this.firstNameDisabled = false;
    this.lastNameDisabled = false;
    this.roleDisabled = false;
    this.providerAccessDisabled = false;
    this.user.isEdit
      ? (this.emailDisabled = true)
      : (this.emailDisabled = false);
  }

  private disableEditFields() {
    this.firstNameDisabled = true;
    this.lastNameDisabled = true;
    this.emailDisabled = true;
    this.roleDisabled = true;
    this.providerAccessDisabled = true;
  }

  //A function that disables every item when corporate access is true
  public isDisabled = (dataItem: any) => {
    if (this.isCorporateUser) {
      return dataItem;
    }
  };

  // Set sp mobile technician flag for keymaster api call
  public onCorporateAccessChange(event: any) {
    this.isCorporateUser = <boolean>event.target.checked;
    if (this.isCorporateUser) {
      this.displaySiteTierValidation = false;
      this.isCustomerPriorityEditor = false;
    }
  }

  public onCustomerQuoteViewerChange(event: any) {
    this.isCustomerQuoteViewer = <boolean>event.target.checked;
  }

  public onCustomerQuoteApproverChange(event: any) {
    this.isCustomerQuoteApprover = <boolean>event.target.checked;
    this.updateQuoteLimit(event);
  }

  public onCustomerInvoiceViewerChange(event: any) {
    this.isCustomerInvoiceViewer = <boolean>event.target.checked;
  }

  public onReportViewerChange(event: any) {
    this.isReportViewer = <boolean>event.target.checked;
  }
  public onCustomerRunReportViewerChange(event: any) {
    this.isCustomerRunReportViewer = <boolean>event.target.checked;
    if (this.isCustomerRunReportViewer) {
      this.isReportViewer = this.isCustomerRunReportViewer;
    }
  }
  public onCustomerPriorityEditor(event: any) {
    this.isCustomerPriorityEditor = <boolean>event.target.checked;
  }

  public onSelectedAccessProviderChange(selectedValue: any) {
    this.selectedAccessProviderNumber = this.spAccessNumber = [];
    this.spAccessNumber.push(selectedValue);
    this.selectedAccessProviderNumber = this.spAccessNumber[0];
  }

  public close(isActionPerformed: boolean): void {
    this.closed.emit({ isActionPerformed: isActionPerformed });
    this.opened = false;
  }

  /**
   * Update hasChanges Boolean
   */
  changesMade(): boolean {
    return (
      this.templateForm.controls.email.dirty ||
      this.templateForm.controls.firstName.dirty ||
      this.templateForm.controls.lastName.dirty ||
      this.hasChanges
    );
  }

  updateChanges() {
    this.hasChanges = true;
  }

  onValueChangePersonaList($event) {
    this.hasChanges = true;
    this.groupsOnly = this.originalData.filter(
      specificGrp =>
        specificGrp.persona === $event.persona && specificGrp.type === 'group'
    );
    this.groupList = this.groupsOnly;
    this.initialGroup = [];
    this.initialGroup = this.personasList.filter(
      pGroup => pGroup.persona === $event.persona
    );

    if (this.title === CustomerNewUserComponent.CUSTOMERADD) {
      this.personaSelected = '';
      this.personaSelected = $event;
      this.user.metadata.customer = new CustomerModel();
      this.user.metadata.serviceProvider = new ServiceProviderModel();
      this.initialGroup = this.initialGroup[0];
      this.groupsSelected = [];
    } else {
      if (!this.user.metadata.serviceProvider) {
        this.user.metadata.serviceProvider = new ServiceProviderModel();
      }

      if (!this.user.metadata.customer) {
        this.user.metadata.customer = new CustomerModel();
      }

      if (this.personaName === $event.persona) {
        this.groupsSelected = this.tempGroupsSelected;
        if (
          this.selectedProviders &&
          this.selectedProviders.serviceProviderNumbers &&
          this.selectedProviders.serviceProviderNumbers.length > 0
        ) {
          this.user.metadata.serviceProvider = this.selectedProviders;
        }
        if (this.selectedCustomers) {
          this.user.metadata.customer = this.selectedCustomers;
        }
      } else {
        this.groupsSelected = [];
        this.user.metadata.serviceProvider = new ServiceProviderModel();
        this.user.metadata.customer = new CustomerModel();
      }
    }

    // reset form element: groups to pristine state
    if (this.templateForm.controls && this.templateForm.controls.groups) {
      this.templateForm.controls.groups.markAsPristine();
      this.templateForm.controls.groups.markAsUntouched();
    }
  }

  removeDuplicateElements(duplicateValueArray: any[]) {
    let uniqueElementsArray = duplicateValueArray.filter(function(
      elem,
      index,
      self
    ) {
      return index === self.indexOf(elem);
    });
    return uniqueElementsArray;
  }

  flattenArray(nestedArray: any[]) {
    return nestedArray.reduce(
      (accumulator, value) => accumulator.concat(value),
      []
    );
  }

  /**
   * On Save button click.
   */
  onSave(): void {
    this.customerSubmit = true;
    if (this.isTierDataAvailable) {
      this.RemoveDeselectKey();
      this.formDataWithSelectionInformation(this.siteTierData);
      this.getSelectedIds(this.siteTierData);
      this.selectedKeys = this.flattenArray(this.selectedKeys);
    }

    if (this.user.isEdit && this.isTierDataAvailable) {
      const lengthOfSite = this.editSiteTiers ? this.editSiteTiers.length : 0;
      const lengthOfTier = this.editSiteIds ? this.editSiteIds.length : 0;
      //no edit has been made on tiers & sites
      if (this.checkedKeys.length == lengthOfSite + lengthOfTier) {
        this.selectedKeys.push(this.editSiteIds);
        this.selectedKeys.push(this.editSiteTiers);
      } else {
        //data has not been loaded for child level and changes have been made only at parent level
        this.editSiteTiers.forEach(tierId => {
          if (!this.loadedTierIds.find(x => x == tierId)) {
            this.selectedKeys.push(tierId);
          }
        });

        this.editSiteIds.forEach(siteId => {
          if (!this.loadedSiebelSiteIds.find(x => x == siteId)) {
            this.selectedKeys.push(siteId);
          }
        });
      }
    }

    if (this.selectedKeys && this.selectedKeys.length) {
      this.selectedKeys = this.removeDuplicateElements(this.selectedKeys);
    } else {
      this.siteIds = this.selectedSiteNumbers;
    }

    if (!this.isCorporateUser) {
      this.getSiteTierId();
    }

    if (this.title === CustomerNewUserComponent.CUSTOMEREDIT) {
      this.editUser(this.user);
    } else {
      this.createUser(
        this.user,
        this.isCustomerQuoteViewer,
        this.isCustomerQuoteApprover,
        this.isCustomerInvoiceViewer,
        this.isReportViewer,
        this.isCustomerRunReportViewer,
        this.isCustomerPriorityEditor
      );
    }
  }

  getSiteTierId() {
    let selectedKeys = this.selectedKeys;
    selectedKeys.forEach((id: any) => {
      if (typeof id === 'number') {
        this.siteTiers.push(id);
      } else {
        this.siteIds.push(id);
      }
    });
  }

  /**
   * Perform the add and remove operations if detected on user selections.
   * @param newGroups
   * @param user
   */
  private createUser(
    user: any,
    isCustomerQuoteViewer: boolean,
    isCustomerQuoteApprover: boolean,
    isCustomerInvoiceViewer: boolean,
    isReportViewer: boolean,
    isCustomerRunReportViewer: boolean,
    isCustomerPriorityEditor: boolean
  ): void {
    this.startProgress();
    user.customerNumbers = [];

    this.selectedCustomer.forEach(cust => {
      user.customerNumbers.push(cust.number);
    });

    user.siteIds =
      this.siteIds && this.siteIds
        ? this.checkInvalidData(this.siteIds, 'string')
        : [];
    user.siteTiers =
      this.siteTiers && this.siteTiers
        ? this.checkInvalidData(this.siteTiers, 'number').map(String)
        : [];

    user.claims = this.setClaimProperties(user);

    this.pendingDuplicateRolesSnapshot = {
      isCustomerQuoteViewer,
      isCustomerQuoteApprover,
      isCustomerInvoiceViewer,
      isReportViewer,
      isCustomerRunReportViewer,
      isCustomerPriorityEditor
    };

    this.submitCreateCustomerUser(user, false);
  }

  private submitCreateCustomerUser(
    user: any,
    enableExistingRegisteredUser: boolean
  ): void {
    this.usersService
      .createCustomerUser(user, enableExistingRegisteredUser)
      .subscribe(
        result => {
          user.id = result.id;
        },
        (errorResponse: any) => {
          const errorBody =
            errorResponse && errorResponse.error
              ? errorResponse.error
              : errorResponse;
          if (
            !enableExistingRegisteredUser &&
            errorBody &&
            errorBody.duplicate
          ) {
            this.promptEnableExistingUser(user);
            return;
          }
          this.customerSubmit = false;
          this.pendingDuplicateRolesSnapshot = null;
          this.onAPIError(
            errorBody && errorBody.message
              ? errorBody.message
              : 'An error occurred while creating the user.'
          );
        },
        () => {
          this.addGroupsAfterCreate(user);
        }
      );
  }

  private promptEnableExistingUser(user: any): void {
    this.finishProgress();
    this.customerSubmit = false;
    this.dialogService
      .open(ConfirmationComponent, [
        {
          provide: ConfirmationModel,
          useValue: new ConfirmationModel(
            'Existing User',
            'User already registered. Enable this user?'
          )
        }
      ])
      .then(confirmed => {
        if (confirmed) {
          this.customerSubmit = true;
          this.startProgress();
          this.submitCreateCustomerUser(user, true);
        } else {
          this.pendingDuplicateRolesSnapshot = null;
          this.toastr.info('No changes were made to the existing user.');
          this.close(false);
        }
      });
  }

  private addGroupsAfterCreate(user: any): void {
    const roles = this.pendingDuplicateRolesSnapshot;
    let groupsToAdd: Array<any> = [];

    groupsToAdd.push(
      this.groupLookup.get(CustomerNewUserComponent.CUSTOMERGROUP)
    );

    if (roles && roles.isCustomerQuoteViewer) {
      groupsToAdd.push(
        this.groupLookup.get(CustomerNewUserComponent.CUSTOMERQUOTEVIEWERGROUP)
      );
    }

    if (roles && roles.isCustomerQuoteApprover) {
      groupsToAdd.push(
        this.groupLookup.get(
          CustomerNewUserComponent.CUSTOMERQUOTEAPPROVERGROUP
        )
      );
    }

    if (roles && roles.isCustomerInvoiceViewer) {
      groupsToAdd.push(
        this.groupLookup.get(
          CustomerNewUserComponent.CUSTOMERINVOICEVIEWERGROUP
        )
      );
    }

    if (roles && roles.isReportViewer) {
      groupsToAdd.push(
        this.groupLookup.get(CustomerNewUserComponent.REPORTVIEWERGROUP)
      );
    }
    if (roles && roles.isCustomerRunReportViewer) {
      groupsToAdd.push(
        this.groupLookup.get(
          CustomerNewUserComponent.CUSTOMERRUNREPORTVIEWERGROUP
        )
      );
    }
    if (roles && roles.isCustomerPriorityEditor) {
      groupsToAdd.push(
        this.groupLookup.get(
          CustomerNewUserComponent.CUSTOMERPRIORITYEDITORGROUP
        )
      );
    }
    let assignedGroups: Array<any> = [];
    groupsToAdd.forEach((serviceProvider: any) => {
      if (serviceProvider) {
        let spGroupObject: any = {};
        spGroupObject['userId'] = user.id;
        spGroupObject['groupId'] = serviceProvider.id;
        assignedGroups.push(spGroupObject);
      }
    });

    this.usersService
      .addGroups(assignedGroups.map(item => item.groupId), user.id)
      .subscribe(
        () => {
          this.customerSubmit = false;
          this.pendingDuplicateRolesSnapshot = null;
          this.onAPISuccess('User Created successfully');
          this.close(true);
        },
        () => {
          this.customerSubmit = false;
          this.pendingDuplicateRolesSnapshot = null;
          this.onAPIError('An error occurred while adding User Groups');
        }
      );
  }

  /**
   * Perform the add and remove operations if detected on user selections.
   * @param newGroups
   * @param removedGroups
   * @param user
   */
  private editUser(user: any): void {
    this.loadingIndicator = true;
    this.startProgress();
    let apiCalls: Array<Observable<any>> = [];
    let operationResults: Array<any> = [null, null, null];
    let isSuccess = false;
    user.customerNumbers = [];

    this.selectedCustomer.forEach(cust => {
      user.customerNumbers.push(cust.number);
    });
    let groupsToAdd: Array<any> = [];
    let groupsToRemove: Array<any> = [];

    groupsToAdd.push(
      this.groupLookup.get(CustomerNewUserComponent.CUSTOMERGROUP)
    );

    if (this.isCustomerQuoteViewer && !this.isCustomerQuoteViewerAdded) {
      groupsToAdd.push(
        this.groupLookup.get(CustomerNewUserComponent.CUSTOMERQUOTEVIEWERGROUP)
      );
    }

    if (this.isCustomerQuoteApprover && !this.isCustomerQuoteApproverAdded) {
      groupsToAdd.push(
        this.groupLookup.get(
          CustomerNewUserComponent.CUSTOMERQUOTEAPPROVERGROUP
        )
      );
    }

    if (this.isCustomerInvoiceViewer && !this.isCustomerInvoiceViewerAdded) {
      groupsToAdd.push(
        this.groupLookup.get(
          CustomerNewUserComponent.CUSTOMERINVOICEVIEWERGROUP
        )
      );
    }

    if (this.isReportViewer && !this.isReportViewerAdded) {
      groupsToAdd.push(
        this.groupLookup.get(CustomerNewUserComponent.REPORTVIEWERGROUP)
      );
    }
    if (this.isCustomerPriorityEditor && !this.isCustomerPriorityEditorAdded) {
      groupsToAdd.push(
        this.groupLookup.get(
          CustomerNewUserComponent.CUSTOMERPRIORITYEDITORGROUP
        )
      );
    }
    if (
      this.isCustomerRunReportViewer &&
      !this.isCustomerRunReportViewerAdded
    ) {
      groupsToAdd.push(
        this.groupLookup.get(
          CustomerNewUserComponent.CUSTOMERRUNREPORTVIEWERGROUP
        )
      );
    }
    let assignedGroups: Array<any> = [];
    groupsToAdd.forEach((serviceProvider: any) => {
      if (serviceProvider) {
        let spGroupObject: any = {};
        spGroupObject['userId'] = user.id;
        spGroupObject['groupId'] = serviceProvider.id;
        assignedGroups.push(spGroupObject);
      }
    });

    if (assignedGroups.length > 0) {
      apiCalls.push(
        this.usersService.addGroups(
          assignedGroups.map(item => item.groupId),
          user.id
        )
      );
    }

    if (!this.isCustomerQuoteViewer && this.isCustomerQuoteViewerAdded) {
      groupsToRemove.push(
        this.groupLookup.get(CustomerNewUserComponent.CUSTOMERQUOTEVIEWERGROUP)
      );
    }

    if (!this.isCustomerQuoteApprover && this.isCustomerQuoteApproverAdded) {
      groupsToRemove.push(
        this.groupLookup.get(
          CustomerNewUserComponent.CUSTOMERQUOTEAPPROVERGROUP
        )
      );
    }

    if (!this.isCustomerInvoiceViewer && this.isCustomerInvoiceViewerAdded) {
      groupsToRemove.push(
        this.groupLookup.get(
          CustomerNewUserComponent.CUSTOMERINVOICEVIEWERGROUP
        )
      );
    }

    if (!this.isReportViewer && this.isReportViewerAdded) {
      groupsToRemove.push(
        this.groupLookup.get(CustomerNewUserComponent.REPORTVIEWERGROUP)
      );
    }
    if (!this.isCustomerPriorityEditor && this.isCustomerPriorityEditorAdded) {
      groupsToRemove.push(
        this.groupLookup.get(
          CustomerNewUserComponent.CUSTOMERPRIORITYEDITORGROUP
        )
      );
    }
    if (
      !this.isCustomerRunReportViewer &&
      this.isCustomerRunReportViewerAdded
    ) {
      groupsToRemove.push(
        this.groupLookup.get(
          CustomerNewUserComponent.CUSTOMERRUNREPORTVIEWERGROUP
        )
      );
    }

    let removedGroups: Array<any> = [];
    groupsToRemove.forEach((serviceProvider: any) => {
      let spGroupObject: any = {};
      spGroupObject['userId'] = user.id;
      spGroupObject['groupId'] = serviceProvider.id;
      removedGroups.push(spGroupObject);
    });

    if (removedGroups.length > 0) {
      apiCalls.push(
        this.usersService.deleteGroups(
          removedGroups.map(item => item.groupId),
          user.id
        )
      );
    }

    user.siteIds =
      this.siteIds && this.siteIds
        ? this.checkInvalidData(this.siteIds, 'string')
        : [];
    user.siteTiers =
      this.siteTiers && this.siteTiers
        ? this.checkInvalidData(this.siteTiers, 'number').map(String)
        : [];

    user.claims = this.setClaimProperties(user);

    apiCalls.push(this.usersService.updateCustomerUser(user));

    if (this.initialUserStatus != user.status) {
      apiCalls.push(this.usersService.updateUserAccountStatus(user));
    }

    const observables = forkJoin<any>(apiCalls);
    observables.subscribe({
      next: results => {
        if (results.length === 3) {
          operationResults = results.map((item: any) => item.success);
        } else {
          operationResults[2] = results[0];
        }
      },
      complete: () => {
        this.customerSubmit = false;
        this.onAPISuccess('User has been successfully updated');
        isSuccess = true;
        this.loadingIndicator = false;
        this.finishProgress();
        this.close(isSuccess);
      }
    });
  }

  setClaimProperties(user) {
    user.claims = [];

    if (this.user.QuoteApprovalLimit && this.isQuoteLimitViewer) {
      let obj = {
        claimType: this.claimQuoteApproverLimit,
        claimValue: this.user.QuoteApprovalLimit.toString()
      };
      user.claims.push(obj);
    }

    if (this.isCorporateUser) {
      let obj = {
        claimType: this.claimCorporateAccess,
        claimValue: user.customerNumbers.toString()
      };
      user.claims.push(obj);
    }

    return user.claims;
  }

  checkInvalidData(siteTierIds, type) {
    var data = this.flattenArray(siteTierIds);
    return data.filter(item => typeof item == type);
  }

  /**
   * On Cancel/Close button event.
   */
  onCancelClose(): void {
    this.close(false);
  }

  /**
   * Validate FirstName
   */
  firstNameValidation(): boolean {
    return (
      this.templateForm.controls.firstName &&
      this.templateForm.controls.firstName.errors &&
      (this.templateForm.controls.firstName.dirty ||
        this.templateForm.controls.firstName.touched)
    );
  }

  /**
   * Validate LastName
   */
  lastNameValidation(): boolean {
    return (
      this.templateForm.controls.lastName &&
      this.templateForm.controls.lastName.errors &&
      (this.templateForm.controls.lastName.dirty ||
        this.templateForm.controls.lastName.touched)
    );
  }

  /**
   * Checks if email is a vixxo email
   * @param email string
   */
  private checkVixxoEmail(email: any): void {
    if (email) {
      this.isVixxoEmail =
        email.toLowerCase().indexOf('@vixxo.com') >= 0 ? true : false;
    }
  }

  /**
   * Validate Email
   */
  emailValidation(): boolean {
    return (
      this.templateForm.controls.email &&
      this.templateForm.controls.email.errors &&
      (this.templateForm.controls.email.dirty ||
        this.templateForm.controls.email.touched)
    );
  }

  /**
   * Validate no special characters or numbers
   */
  specialCharCheck(name: string): boolean {
    if (name) {
      return !/^[A-Za-z]+$/.test(name);
    } else {
      return false;
    }
  }

  /**
   * Validate group present for Add user
   */
  groupCheck(): boolean {
    return (
      this.personaSelected &&
      this.personaSelected.persona === 'Admin Portal' &&
      (this.groupsSelected === undefined || this.groupsSelected.length === 0)
    );
  }

  resetButtonVisibilityCheck(): boolean {
    if (this.title === CustomerNewUserComponent.CUSTOMEREDIT) {
      if (
        this.authService.isUsersManagerAdmin() ||
        this.authService.isEnterpriseSPUserManager()
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  /**
   * Validate persona present for User
   */
  personaCheck(): boolean {
    return this.personaSelected === undefined || !this.personaSelected.persona;
  }

  /**
   * Validate The User Can Save
   */
  saveDisabled(): boolean {
    return (
      !this.user.firstName ||
      !this.user.lastName ||
      !this.user.email ||
      (this.isVixxoEmail &&
        this.templateForm.controls.email &&
        this.templateForm.controls.email.dirty) ||
      (!this.isValidEmail &&
        this.templateForm.controls.email &&
        this.templateForm.controls.email.dirty) ||
      this.emailTooLong ||
      this.isAuth0EmailExists ||
      (this.showNoQuoteLimitInputError || this.showQuoteLimitError) ||
      !(this.selectedCustomer.length > 0) ||
      !this.checkForSiteTier()
    );
  }

  checkForSiteTier() {
    return this.isCorporateUser
      ? true
      : this.isTierDataAvailable
      ? this.checkedKeys.length > 0
      : this.selectedSiteNumbers.length > 0;
  }

  /**
   * Only allow alphabetical characters
   * @param e character the user keypresses
   */
  protected alphaOnly(e) {
    const key = e.keyCode;
    return (key >= 65 && key <= 90) || (key >= 97 && key <= 122) || key === 32;
  }

  /**
   * Checks if email is a valid email
   * @param email string
   */
  private checkValidEmail(email) {
    let emailRegex = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    this.isValidEmail = emailRegex.test(email) ? true : false;
  }

  /**
   * Checks if vemail is too long for auth0 to save
   * @param email string
   */
  private checkLongEmail(email) {
    if (email.indexOf('@') > 0) {
      this.emailTooLong =
        email.split('@')[0].length > 64 || email.split('@')[1].length > 254
          ? true
          : false;
    }
  }

  /**
   * Checks if valid email, vixxo email, and long email
   * @param email string
   */
  protected emailValidations(email): void {
    this.checkLongEmail(email);
    this.checkValidEmail(email);
    this.checkVixxoEmail(email);
    if (this.isValidEmail && !this.emailTooLong && !this.isVixxoEmail) {
      this.validateAuth0EmailExists();
      this.federatedSSOMatch = matchExternalSSO(email || '');
    } else {
      this.isAuth0EmailExists = false;
      this.federatedSSOMatch = false;
    }
  }

  protected onStatusClicked(): void {
    if (this.statusSwitch === true) {
      this.statusActive = 'Active';
      this.user.status = 'Active';
      this.enableEditFields();
    } else {
      this.statusActive = 'Inactive';
      this.user.status = 'Deactivated';
      this.disableEditFields();
    }
  }

  /**
   * Validates the Email exists in Auth0
   * @param email: string
   */
  public validateAuth0EmailExists(): void {
    this.usersService
      .validateEmailExists(this.user.email.toLowerCase())
      .subscribe(
        (res: any) => {
          const userExists = !!(res && res.success && res.validateEmail);
          const metadataExists = !!(res && res.success && res.metadataExists);
          if (
            res.success &&
            this.title === CustomerNewUserComponent.CUSTOMEREDIT &&
            this.customerUser.email.toLowerCase() ===
              this.user.email.toLowerCase()
          ) {
            this.isAuth0EmailExists = false;
          } else if (!userExists) {
            this.isAuth0EmailExists = false;
          } else if (userExists && metadataExists) {
            this.isAuth0EmailExists = true;
          } else {
            this.isAuth0EmailExists = false;
          }
        },
        () => {
          this.onAPIError(
            'An error occurred while validating email already exist'
          );
          this.isAuth0EmailExists = false;
        }
      );
  }

  public updateQuoteLimit(event: any) {
    if (event.target.checked) {
      this.isQuoteLimitViewer = true;
      this.validateQuoteLimit();
    } else {
      this.isQuoteLimitViewer = false;
      //this.quoteLimitNumberEntry = null;
      this.showQuoteLimitError = false;
      this.showNoQuoteLimitInputError = false;
    }
  }

  // Formats the currency value entered into the quote limit input
  public formatQuoteLimit(quoteLimitNumberEntry: any): void {
    if (quoteLimitNumberEntry === 0) {
      this.quoteLimitNumberEntry = 0;
      return;
    } else if (!quoteLimitNumberEntry || quoteLimitNumberEntry < 0) {
      this.quoteLimitNumberEntry = null;
      return;
    }
    const numberDecimalPlaces = quoteLimitNumberEntry
      ? quoteLimitNumberEntry.toString().split('.')
      : [];

    if (numberDecimalPlaces.length === 2) {
      this.quoteLimitNumberEntry = parseFloat(
        numberDecimalPlaces[0].slice(0, 8) +
          '.' +
          numberDecimalPlaces[1].slice(0, 0)
      );
    } else {
      this.quoteLimitNumberEntry = parseInt(
        numberDecimalPlaces[0].slice(0, 8),
        10
      );
    }
  }

  public validateQuoteLimit() {
    let quoteLimit = parseInt(
      this.user.QuoteApprovalLimit != undefined &&
        this.user.QuoteApprovalLimit != ''
        ? this.user.QuoteApprovalLimit
        : ''
    );

    if (quoteLimit == 0) {
      this.showQuoteLimitError = true;
      this.showNoQuoteLimitInputError = false;
    } else if (!quoteLimit) {
      this.showQuoteLimitError = false;
      this.showNoQuoteLimitInputError = true;
    } else {
      this.showQuoteLimitError = false;
      this.showNoQuoteLimitInputError = false;
    }
  }

  keyPressNumbers(event) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  /**
   * Filter customer from multiselect dropdown
   *
   */
  onFilterChange(filter: string) {
    if (filter.length > 0) {
      this.allCustomers = this.originalAllCustomers.filter(
        item =>
          item.name.toLowerCase().includes(filter.toLowerCase()) ||
          item.number.toLowerCase().includes(filter.toLowerCase())
      );
    } else {
      this.allCustomers = this.originalAllCustomers;
      this.kendoMultiSelectInstance.toggle(false);
    }
  }

  /**
   * Filter group list.
   * @param $event
   */
  onValueChange(customers): void {
    let customerNumbers = [];
    if (customers && customers.length > 0) {
      customers.forEach(cust => {
        customerNumbers.push(cust.number);
      });
    }
    this.selectedCustomer = customers;
  }

  /**
   * check special characters
   *
   */
  protected checkSpecialChar(e): any {
    if (
      (e.which < 48 && e.which !== 45) ||
      (e.which > 57 && e.which < 65) ||
      (e.which > 90 && e.which < 97) ||
      e.which > 122
    ) {
      e.preventDefault();
    }
  }

  loadSitesTreeView(sites: SearchSiteTier[]) {
    this.siteTierArray = [];
    for (let count = 1; count <= 5; count++) {
      if (sites[0]['level' + count + 'Name']) {
        this.AddTier(sites, count);
      } else {
        this.AddSite(sites, count);
        break;
      }
    }
    this.siteTierArray.push(this.siteTierMap);
  }

  AddTier(sites: any, index: number) {
    switch (index) {
      case 1:
        this.siteTierMap = {
          text: sites[0]['level' + index + 'Name'],
          items: []
        };
        break;
      case 2:
        this.siteTierMap.items.push({
          text: sites[0]['level' + index + 'Name'],
          items: []
        });
        break;
      case 3:
        this.siteTierMap.items[0].items.push({
          text: sites[0]['level' + index + 'Name'],
          items: []
        });
        break;
      case 4:
        this.siteTierMap.items[0].items[0].items.push({
          text: sites[0]['level' + index + 'Name'],
          items: []
        });
        break;
      case 5:
        this.siteTierMap.items[0].items[0].items[0].items.push({
          text: sites[0]['level' + index + 'Name'],
          items: []
        });
        break;
      default:
        'No value found';
    }
  }

  AddSite(sites: any, index: number) {
    switch (index) {
      case 1:
        this.siteTierMap = {
          text: this.customerNumber,
          items: []
        };
        this.siteTierMap.items.push({
          text: sites[0]['siteName'],
          value: sites[0]['siebelSiteId']
        });
        break;
      case 2:
        this.siteTierMap.items.push({
          text: sites[0]['siteName'],
          value: sites[0]['siebelSiteId']
        });
        break;
      case 3:
        this.siteTierMap.items[0].items.push({
          text: sites[0]['siteName'],
          value: sites[0]['siebelSiteId']
        });
        break;
      case 4:
        this.siteTierMap.items[0].items[0].items.push({
          text: sites[0]['siteName'],
          value: sites[0]['siebelSiteId']
        });
        break;
      case 5:
        this.siteTierMap.items[0].items[0].items[0].items.push({
          text: sites[0]['siteName'],
          value: sites[0]['siebelSiteId']
        });
        break;
      default:
        'No value found';
        break;
    }
  }
}
